import MapEventClass, * as MapEventModule from 'ol/MapEvent.js';

// Create a wrapper class
class MapEvent extends MapEventClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in MapEventModule) {
    if (key !== "default") {
        MapEvent[key] = MapEventModule[key];
    }
}

export default MapEvent;

// Re-export ALL named exports from OL
export * from 'ol/MapEvent.js';